import React from 'react';

const FallBack = (props) => {
  return <div>URL Not Found</div>;
};

export default FallBack;
